import { ViewObserver } from '@montugroup/design-system';
import type { PropsWithChildren } from 'react';

type PredicatedViewObserverProps = {
  id: string;
  enabled: boolean;
} & PropsWithChildren;

export const PredicatedViewObserver = (props: PredicatedViewObserverProps) => {
  const { children, enabled, id } = props;
  if (enabled) {
    return <ViewObserver id={id}>{children}</ViewObserver>;
  }
  return children;
};
